import React from 'react';
import { Industry, FormErrors } from '../types';

interface BasicInfoSectionProps {
  formData: Industry;
  setFormData: (data: Industry) => void;
  errors: FormErrors;
}

const BasicInfoSection: React.FC<BasicInfoSectionProps> = ({
  formData,
  setFormData,
  errors,
}) => {
  const handleChange = (field: keyof Industry, value: string | boolean | null) => {
    setFormData({ ...formData, [field]: value });
  };

  return (
    <div>
      <div className="mb-3">
        <label htmlFor="name" className="form-label">
          業界名 <span className="text-danger">*</span>
        </label>
        <input
          type="text"
          className={`form-control ${errors.name ? 'is-invalid' : ''}`}
          id="name"
          value={formData.name || ''}
          onChange={(e) => handleChange('name', e.target.value)}
          required
        />
        {errors.name && <div className="invalid-feedback">{errors.name.join(', ')}</div>}
      </div>

      <div className="mb-3">
        <label htmlFor="slug" className="form-label">
          スラッグ
        </label>
        <input
          type="text"
          className={`form-control ${errors.slug ? 'is-invalid' : ''}`}
          id="slug"
          value={formData.slug || ''}
          onChange={(e) => handleChange('slug', e.target.value)}
          placeholder="自動生成されます"
        />
        <small className="form-text text-muted">URL用のスラッグ（空の場合は自動生成）</small>
        {errors.slug && <div className="invalid-feedback">{errors.slug.join(', ')}</div>}
      </div>

      <div className="mb-3">
        <label htmlFor="synonyms" className="form-label">
          シノニム（改行区切り）
        </label>
        <textarea
          className={`form-control ${errors.synonyms ? 'is-invalid' : ''}`}
          id="synonyms"
          rows={3}
          value={formData.synonyms || ''}
          onChange={(e) => handleChange('synonyms', e.target.value)}
          placeholder="FinTech&#10;金融技術&#10;フィンテック"
        />
        <small className="form-text text-muted">類義語を改行区切りで入力してください</small>
        {errors.synonyms && <div className="invalid-feedback">{errors.synonyms.join(', ')}</div>}
      </div>

      <div className="mb-3">
        <div className="form-check">
          <input
            className="form-check-input"
            type="checkbox"
            id="published"
            checked={formData.published || false}
            onChange={(e) => handleChange('published', e.target.checked)}
          />
          <label className="form-check-label" htmlFor="published">
            公開ステータス
          </label>
        </div>
      </div>

      <hr className="my-4" />

      <h4 className="mb-3">コンテンツ情報</h4>

      <div className="mb-3">
        <label htmlFor="description" className="form-label">
          説明
        </label>
        <textarea
          className={`form-control ${errors.description ? 'is-invalid' : ''}`}
          id="description"
          rows={8}
          value={formData.description || ''}
          onChange={(e) => handleChange('description', e.target.value)}
        />
        {errors.description && <div className="invalid-feedback">{errors.description.join(', ')}</div>}
      </div>

      <div className="mb-3">
        <label htmlFor="image_url" className="form-label">
          画像URL
        </label>
        <input
          type="text"
          className={`form-control ${errors.image_url ? 'is-invalid' : ''}`}
          id="image_url"
          value={formData.image_url || ''}
          onChange={(e) => handleChange('image_url', e.target.value)}
        />
        {errors.image_url && <div className="invalid-feedback">{errors.image_url.join(', ')}</div>}
      </div>
    </div>
  );
};

export default BasicInfoSection;

